module.exports = __webpack_public_path__ + "static/img/th.caffa5d1.png";